import { getYoutubeVideoEmbedUrl } from "@/functions/getYoutubeVideoEmbedUrl";

/**
 *
 * @param video_embed_url
 * @param title
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function Video({ video_embed_url, title, className }) {
  const video = getYoutubeVideoEmbedUrl(video_embed_url);

  if (!video) {
    return null;
  }

  return (
    <div className={`ratio ratio-16x9 ${className}`}>
      <iframe
        width="1920"
        height="1080"
        src={video}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}

Video.defaultProps = {
  title: "YouTube video player",
  video_embed_url: null,
};